import React, { useState } from "react";
import { IoBusiness, IoPerson, IoMailSharp, IoCall } from "react-icons/io5";
import { BsDot } from "react-icons/bs";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { contact } from "../services/LoginService"; // Assure-toi que le chemin est correct

const ContactFormSection = () => {
    const [societe, setSociete] = useState("");
    const [siret, setSiret] = useState("");
    const [nom, setNom] = useState("");
    const [prenom, setPrenom] = useState("");
    const [email, setEmail] = useState("");
    const [telephone, setTelephone] = useState("");
    const [objet, setObjet] = useState("");
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false); // ⚡ État de chargement

    const tasks = [
        "Nous sommes disponibles pour répondre à toutes vos questions",
        "Organiser un appel ou une démonstration",
        "Vous guider pour vos devis et factures",
        "Support et suivi personnalisé"
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true); // début du chargement

        const formData = { societe, siret, nom, prenom, email, telephone, objet, message };

        try {
            const result = await contact(formData); // Appel API
            if (result.success) {
                toast.success(result.message, { position: "top-right", autoClose: 5000 });
                // Reset du formulaire
                setSociete(""); setSiret(""); setNom(""); setPrenom("");
                setEmail(""); setTelephone(""); setObjet(""); setMessage("");
            } else {
                toast.error(result.message, { position: "top-right", autoClose: 5000 });
            }
        } catch (err) {
            toast.error("Erreur inattendue lors de l'envoi.", { position: "top-right", autoClose: 5000 });
        } finally {
            setIsLoading(false); // fin du chargement
        }
    };

    return (
        <section
            className="bg-color1 pl-4 sm:pl-4 lg:pl-4 xl:pl-4 2xl:pl-24  
                pr-4 flex flex-col lg:flex-row 
                w-full justify-center gap-4 items-center 
                lg:pt-20 pt-20 pb-10  
                font-Poppins"
        >
            {/* Texte explicatif */}
            <div className="flex flex-col gap-5 lg:w-1/2 w-full items-start">
                <p className="font-bold font-Poppins text-color2 text-2xl sm:text-2xl md:text-2xl lg:text-4xl  text-start leading-snug lg:leading-[4rem]">
                    Nous sommes là pour vous
                </p>

                <p className="font-medium font-Poppins text-base sm:text-md md:text-lg lg:text-xl text-color2 w-full text-start leading-relaxed">
                    Vous avez des questions ? Besoin d'une démonstration ou d’un accompagnement personnalisé ?
                    Remplissez le formulaire et nous organiserons un appel pour vous guider pas à pas.
                </p>

                {tasks.length > 0 && (
                    <ul className="flex flex-col gap-2 mt-3 w-full">
                        {tasks.map((task, i) => (
                            <li key={i} className="flex items-center text-start gap-2 text-color2">
                                <BsDot className="text-color3" />
                                <span className="text-base sm:text-md md:text-lg lg:text-xl">{task}</span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            {/* Formulaire */}

            <div className="lg:w-1/2 w-full bg-color2 rounded-3xl p-8 shadow-lg" id="contact">
                <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
                    {/* Rows */}
                    {/* Société & SIRET */}
                    <div className="flex flex-col lg:flex-row gap-4">
                        <div className="relative w-full">
                            <IoBusiness className="absolute left-3 top-1/2 -translate-y-1/2 text-color3" size={18} />
                            <input
                                type="text"
                                placeholder="Société"
                                value={societe}
                                onChange={(e) => setSociete(e.target.value)}
                                className="w-full px-10 py-2 text-black text-sm  rounded-lg border-color3 focus:border-color1 outline-none transition-colors placeholder:text-blue-600 placeholder:font-semibold "
                                required
                            />
                        </div>
                        <div className="relative w-full">
                            <IoBusiness className="absolute left-3 top-1/2 -translate-y-1/2 text-color3" size={18} />
                            <input
                                type="text"
                                placeholder="SIRET"
                                value={siret}
                                onChange={(e) => setSiret(e.target.value)}
                                className="w-full px-10 py-2 text-black text-sm  rounded-lg border-color3 focus:border-color1 outline-none transition-colors placeholder:text-blue-600 placeholder:font-semibold"
                                required
                            />
                        </div>
                    </div>

                    {/* Nom & Prénom */}
                    <div className="flex flex-col lg:flex-row gap-4">
                        <div className="relative w-full">
                            <IoPerson className="absolute left-3 top-1/2 -translate-y-1/2 text-color3" size={18} />
                            <input
                                type="text"
                                placeholder="Nom"
                                value={nom}
                                onChange={(e) => setNom(e.target.value)}
                                className="w-full px-10 py-2 text-black text-sm  rounded-lg border-color3 focus:border-color1 outline-none transition-colors placeholder:text-blue-600 placeholder:font-semibold"
                                required
                            />
                        </div>
                        <div className="relative w-full">
                            <IoPerson className="absolute left-3 top-1/2 -translate-y-1/2 text-color3" size={18} />
                            <input
                                type="text"
                                placeholder="Prénom"
                                value={prenom}
                                onChange={(e) => setPrenom(e.target.value)}
                                className="w-full px-10 py-2 text-black text-sm  rounded-lg border-color3 focus:border-color1 outline-none transition-colors placeholder:text-blue-600 placeholder:font-semibold"
                                required
                            />
                        </div>
                    </div>

                    {/* Email & Téléphone */}
                    <div className="flex flex-col lg:flex-row gap-4">
                        <div className="relative w-full">
                            <IoMailSharp className="absolute left-3 top-1/2 -translate-y-1/2 text-color3" size={18} />
                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-10 py-2 text-black text-sm  rounded-lg border-color3 focus:border-color1 outline-none transition-colors placeholder:text-blue-600 placeholder:font-semibold"
                                required
                            />
                        </div>
                        <div className="relative w-full">
                            <IoCall className="absolute left-3 top-1/2 -translate-y-1/2 text-color3" size={18} />
                            <input
                                type="tel"
                                placeholder="Téléphone"
                                value={telephone}
                                onChange={(e) => setTelephone(e.target.value)}
                                className="w-full px-10 py-2 text-black text-sm  rounded-lg border-color3 focus:border-color1 outline-none transition-colors placeholder:text-blue-600 placeholder:font-semibold"
                                required
                            />
                        </div>
                    </div>

                    {/* Objet */}
                    <div className="relative w-full">
                        <input
                            type="text"
                            placeholder="Objet du message"
                            value={objet}
                            onChange={(e) => setObjet(e.target.value)}
                            className="w-full px-4 py-2 text-black text-sm  rounded-lg border-color3 focus:border-color1 outline-none transition-colors placeholder:text-blue-600 placeholder:font-semibold"
                            required
                        />
                    </div>

                    {/* Message */}
                    <div className="relative w-full">
                        <textarea
                            placeholder="Message"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            className="w-full px-4 py-2 text-black text-sm h-36 resize-none  rounded-lg border-color3 focus:border-color1 placeholder:text-blue-600 placeholder:font-semibold  outline-none transition-colors"
                            required
                        />
                    </div>

                    {/* Bouton / Loading */}
                    <div className="flex justify-center">
                        <button
                            type="submit"
                            disabled={isLoading} // désactive pendant l'envoi
                            className={`bg-color3 text-white font-bold rounded-xl px-6 py-2 transition-opacity ${isLoading ? "opacity-70 cursor-not-allowed" : "hover:opacity-90"
                                }`}
                        >
                            {isLoading ? "Envoi en cours..." : "Envoyer"}
                        </button>
                    </div>
                </form>
            </div>

            {/* Toast Container */}
            <ToastContainer />
        </section>
    );
};

export default ContactFormSection;
